<template>
   <div class="social-media">
    <a href="https://www.facebook.com"><div class="social-item item1 active"></div></a>
    <a href="https://www.vk.com"><div class="social-item item2 active"></div></a>
    <a href="https://www.instagram.com"><div class="social-item item3 active"></div></a>
    <a href="https://www.telegram.com"><div class="social-item item4 active"></div></a>
  </div>
</template>

<script>

export default {
  name: 'social'
}
</script>

<style scoped>

.social-media
{
  height: 40px;
  width: 12vw;
  position: absolute;
  bottom: 30px;
  right: 30px;
  display: flex;
  justify-content: space-between;
}

.social-media a
{
  height: 100%;
  width: 20%;
}

.social-item
{
  height: 100%;
  width: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}

.item1
{
  background-image: url('../assets/facebook.svg');
}

.item2
{
  background-image: url('../assets/vk.svg');
}

.item3
{
  background-image: url('../assets/instagram.svg');
}

.item4
{
  background-image: url('../assets/telegram.svg');
}

@media only screen and (max-width: 900px) {
  .social-media
  {
    height: 10vw;
    width: 50vw;
  }
}

</style>
